'use client';
import { StaffReauth } from './staff-reauth';
export function ExportReauth(props: {title:string;onComplete:()=>Promise<void>;onClose:()=>void}) {
  return <StaffReauth {...props} description={`${props.title}会消耗一次批准的下载次数，传输中断也会计数。填写当前账号口令后继续。`} />;
}
